import React, { useEffect, useState } from "react";
import { TbCube } from "react-icons/tb";
import { IoReorderFourOutline } from "react-icons/io5";
import { BsBagX } from "react-icons/bs";
import { HiOutlineUsers } from "react-icons/hi2";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const Warehouse = () => {
  const [WarehouseUser, setWarehouseUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_warehouses"
      );

      // Safely handle API structure
      const data = response?.data?.data;
      if (Array.isArray(data)) {
        setWarehouseUser(data);
      } else {
        console.warn("Unexpected response structure:", response.data);
        setWarehouseUser([]); // fallback to empty array
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setWarehouseUser([]); // prevent crash
    }
  };

  fetchData();
}, []);


  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_warehouse",
        { warehouse_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setWarehouseUser((prevUser) =>
          prevUser.filter((user) => user.warehouse_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/inventory-warehouse");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Warehouse List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Inventory</a>
                </li>
                <li className="breadcrumb-item active">Warehouse List</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                      Total Product Items{" "}
                    </h4>
                    <p className="text-muted fw-medium fs-22 mb-0">
                      3521 <span className="fs-12">(Items)</span>
                    </p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <TbCube className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                      In Stock Product{" "}
                    </h4>
                    <p className="text-muted fw-medium fs-22 mb-0">
                      1311 <span className="fs-12">(Items)</span>
                    </p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <IoReorderFourOutline className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                      Out Of Stock Product{" "}
                    </h4>
                    <p className="text-muted fw-medium fs-22 mb-0">
                      231 <span className="fs-12">(Items)</span>
                    </p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <BsBagX className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                      Total Visited Customer
                    </h4>
                    <p className="text-muted fw-medium fs-22 mb-0">
                      2334{" "}
                      <span className="badge text-danger bg-danger-subtle fs-12">
                        <i className="bx bx-down-arrow-alt" />
                        4.5%
                      </span>{" "}
                      <span className="fs-12">(Last Week)</span>
                    </p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <HiOutlineUsers className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">All Warehouse List</h4>
                </div>
                <div className="d-flex gap-2 justify-content-between align-items-center">
                  <div className="d-flex gap-2">
                    <Link to="/warehouse-add" className="btn btn-sm btn-blue">
                      Add Data
                    </Link>
                  </div>
                  <div className="dropdown">
                    <a
                      href="#"
                      className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      This Month
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      {/* item*/}
                      <a href="#!" className="dropdown-item">
                        Download
                      </a>
                      {/* item*/}
                      <a href="#!" className="dropdown-item">
                        Export
                      </a>
                      {/* item*/}
                      <a href="#!" className="dropdown-item">
                        Import
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: "20px" }}>
                          <div className="form-check fs-16 ms-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customCheck1"
                            />
                          </div>
                        </th>
                        <th>ID</th>
                        <th>Warehouse Name</th>
                        <th>Location</th>
                        <th>Manager</th>
                        <th>Contact Number</th>
                        <th>Stock Available </th>
                        <th>Stock Shipping</th>
                        <th>Warehouse Revenue</th>
                        <td>Status</td>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {WarehouseUser.map((user, index) => (
                        <tr key={index}>
                          <td>
                            <div className="form-check fs-16 ms-1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customCheck2"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customCheck2"
                              />
                            </div>
                          </td>
                          <td>{index + 1}</td>
                          <td>{user.name}</td>
                          <td>{user.location} </td>
                          <td>{user.manager_name}</td>
                          <td>{user.phone_number}</td>
                          <td>{user.available_stock}</td>
                          <td>{user.stock_shipping}</td>
                          <td>{user.revenue}</td>
                           <td>
                        <span
                          className={`badge bg-${user.status === "active" ? "success" : "danger"}`}
                        >
                          {user.status}
                        </span>
                      </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/warehouse-edit/${user.warehouse_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i class="fa-solid fa-pencil align-middle fs-18"></i>
                              </Link>
                              <span
                               onClick={() => deleteUser(user.warehouse_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i class="fa-solid fa-trash align-middle fs-18"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* end table-responsive */}
              </div>
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Previous
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        3
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export const WarehouseAdd = () => {
  const navigate = useNavigate();

  const initialFormState = {
    name: "",
    location: "",
    manager_name: "",
    phone_number: "",
    available_stock: "",
    stock_shipping: "",
    revenue: "",
    status: "",
  };

  const [warehouseData, setWarehouseData] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setWarehouseData({ ...warehouseData, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_warehouse",
        warehouseData
      );

      if (response.data.success === "1") {
        toast.success(response.data.message || "Warehouse added successfully!");
        navigate("/inventory-warehouse");
      } else {
        toast.error(response.data.message || "Failed to add warehouse");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Warehouse Add</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Warehouse</a>
                </li>
                <li className="breadcrumb-item active">Warehouse Add</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="card">
          <div className="card-body">
            <form onSubmit={submitForm} className="row">
              <div className="mb-3 col-lg-6">
                <label className="form-label">Warehouse Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Enter warehouse name"
                  required
                  value={warehouseData.name}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  name="location"
                  className="form-control"
                  placeholder="Enter Location"
                  required
                  value={warehouseData.location}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Manager</label>
                <input
                  type="text"
                  name="manager_name"
                  className="form-control"
                  placeholder="Enter Managesr Name"
                  required
                  value={warehouseData.manager_name}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Contact Number</label>
                <input
                  type="tel"
                  name="phone_number"
                  className="form-control"
                  placeholder="Enter Contact Number"
                  required
                  value={warehouseData.phone_number}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Stock Available</label>
                <input
                  type="number"
                  name="available_stock"
                  className="form-control"
                  placeholder="Enter available stock"
                  required
                  value={warehouseData.available_stock}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Stock Shipping</label>
                <input
                  type="number"
                  name="stock_shipping"
                  className="form-control"
                  placeholder="Enter stock shipping count"
                  required
                  value={warehouseData.stock_shipping}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Revenue</label>
                <input
                  type="number"
                  name="revenue"
                  className="form-control"
                  placeholder="Enter revenue"
                  required
                  value={warehouseData.revenue}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Status</label>
                <select
                  name="status"
                  className="form-select"
                  required
                  value={warehouseData.status}
                  onChange={handleInput}
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="p-3 mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                    >
                      Save Change
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link
                      to="/inventory-warehouse"
                      className="btn btn-primary w-100"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};



export const WarehouseEdit = () => {
  const initialData = {
    name: "",
    location: "",
    manager_name: "",
    phone_number: "",
    available_stock: "",
    stock_shipping: "",
    revenue: "",
    status: "",
  };

  const [warehouse, setWarehouse] = useState(initialData);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWarehouseData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_Warehouse_by_id",
          { warehouse_id: id }
        );
        setWarehouse(response.data.data);
      } catch (error) {
        console.error("Error fetching warehouse data!", error);
      }
    };

    fetchWarehouseData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setWarehouse({ ...warehouse, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_warehouse",
        { warehouse_id: id, ...warehouse },
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success(response.data.message || "Warehouse updated successfully!");
      navigate("/inventory-warehouse");
    } catch (error) {
      console.error("Error updating warehouse:", error.response?.data || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Edit Warehouse</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Warehouse</a>
                </li>
                <li className="breadcrumb-item active">Warehouse Edit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Warehouse Details</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Warehouse Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={warehouse.name}
                        onChange={changeHandler}
                        required
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Location</label>
                      <input
                        type="text"
                        name="location"
                        className="form-control"
                        value={warehouse.location}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Manager Name</label>
                      <input
                        type="text"
                        name="manager_name"
                        className="form-control"
                        value={warehouse.manager_name}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Contact Number</label>
                      <input
                        type="text"
                        name="phone_number"
                        className="form-control"
                        value={warehouse.phone_number}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <label className="form-label">Stock Available</label>
                      <input
                        type="number"
                        name="available_stock"
                        className="form-control"
                        value={warehouse.available_stock}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <label className="form-label">Stock Shipping</label>
                      <input
                        type="number"
                        name="stock_shipping"
                        className="form-control"
                        value={warehouse.stock_shipping}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <label className="form-label">Revenue</label>
                      <input
                        type="number"
                        name="revenue"
                        className="form-control"
                        value={warehouse.revenue}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        name="status"
                        className="form-select"
                        value={warehouse.status}
                        onChange={changeHandler}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

